import { Spinner } from "react-bootstrap";

/**
 * Reusable Loader component for displaying loading states
 * @param {Object} props
 * @param {string} [props.message="Loading..."] - Custom loading message
 * @param {string} [props.variant="primary"] - Spinner color variant (primary, secondary, success, danger, warning, info, light, dark)
 * @param {boolean} [props.fullScreen=false] - Whether to display loader in full screen overlay
 * @param {string} [props.className] - Additional CSS classes
 */
const Loader = ({
  message = "Loading...",
  variant = "primary",
  fullScreen = false,
  className = "",
}) => {
  const loaderContent = (
    <div className={`text-center py-5 ${className}`}>
      <Spinner animation="border" role="status" variant={variant}>
        <span className="visually-hidden">{message}</span>
      </Spinner>
      {message && <p className="mt-2">{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: 9999,
        }}
      >
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default Loader;
